import { useState } from 'react';

import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { Button } from 'shared/mui/Buttons';
import { Tooltip } from 'shared/mui/Tooltip';

import { NotificationKeyTooltipCard } from './NotificationKeyTooltipCard';

type NotificationKeyTooltipProps = {
  value?: string;
  icon?: React.ReactNode;
  render?: (handleTooltipOpen: VoidFunction) => React.ReactElement;
};

export const NotificationKeyTooltip: React.FC<NotificationKeyTooltipProps> = ({
  value,
  icon,
  render,
}) => {
  const translate = useTypedTranslate();

  const [isShowNotificationKey, setIsShowNotificationKey] = useState(false);
  const handleTooltipOpen = () => {
    setIsShowNotificationKey(true);
  };
  const handleTooltipClose = () => {
    setIsShowNotificationKey(false);
  };

  return (
    <Tooltip
      componentsProps={{
        tooltip: {
          sx: {
            backgroundColor: 'background.default',
            minWidth: '444px',
            boxShadow: '0 0 14px 4px rgba(0, 0, 0, 0.2)',
            padding: 0,
          },
        },
        popper: {
          sx: {
            width: '444px',
          },
        },
      }}
      disableHoverListener
      open={isShowNotificationKey}
      placement="bottom-start"
      title={<NotificationKeyTooltipCard onClose={handleTooltipClose} value={value} />}
    >
      {render ? (
        render(handleTooltipOpen)
      ) : (
        <Button
          label={translate('app.buttons.showValue')}
          onClick={handleTooltipOpen}
          startIcon={icon || <RemoveRedEyeIcon />}
        />
      )}
    </Tooltip>
  );
};
